import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSingleNodeTree = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.9975243,
			d: "M303.908 159.366v289.109M159.366 303.922h289.109"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 49.67,
			d: "M1575.8 1848.83v107.24c0 19.06-13.79 34.54-30.78 34.54h-95.56c-16.99 0-30.79-15.48-30.79-34.54v-107.24c0-19.07 13.8-34.55 30.79-34.55h95.56c16.99 0 30.78 15.48 30.78 34.55",
			transform: "matrix(1.53047 0 0 1.36381 -1987.56 -1850.18)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 49.67,
			d: "M1575.8 1848.83v107.24c0 19.06-13.79 34.54-30.78 34.54h-95.56c-16.99 0-30.79-15.48-30.79-34.54v-107.24c0-19.07 13.8-34.55 30.79-34.55h95.56c16.99 0 30.78 15.48 30.78 34.55",
			transform: "matrix(1.53047 0 0 1.36381 -1547.08 -1850.18)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 49.67,
			d: "M1575.8 1848.83v107.24c0 19.06-13.79 34.54-30.78 34.54h-95.56c-16.99 0-30.79-15.48-30.79-34.54v-107.24c0-19.07 13.8-34.55 30.79-34.55h95.56c16.99 0 30.78 15.48 30.78 34.55",
			transform: "matrix(1.53047 0 0 1.36381 -1547.08 -2290.66)"
		})
	]
});
export default SvgIconSingleNodeTree;
